/* This example requires Tailwind CSS v2.0+ */
import { Fragment } from 'react'
import { Disclosure, Menu, Transition } from '@headlessui/react'
import { BellIcon, MenuIcon, XIcon } from '@heroicons/react/outline'
import {
    Nav,
    NavLink,
    Bars,
    NavMenu,
    NavBtn,
    Cart,
    Logo
  } from '../Navbar/NavbarElements';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

import {React, useState, useEffect} from 'react';

const navigation = [
  { name: 'Home', href: '/', current: true },
  { name: 'Products', href: '/products', current: false },
  { name: <Cart />, href: '/cart', current: false },
]

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export default function NavBarTailwind() {

    const[numProducts, setNumProducts]  = useState(0);

    const UpdateCartNum = () => {
        if (localStorage.getItem("id") === null) {
            localStorage.setItem("id", uuidv4())
        }
        axios.get('https://ggi-store.herokuapp.com/cart', {  
            params: {
                user: localStorage.getItem("id")
            }
        }).then(res => setNumProducts(res.data.length))
        .catch(err => {
            alert("Something is wrong on our side. Please try again later")
            console.log('Error: ' + err)
        });
    }

    useEffect(() => {
        UpdateCartNum();
    });


  return (
    <Disclosure as="nav" className="bg-white-800 mb-4">
      {({ open }) => (
        <>
          <div className="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
            <div className="relative flex items-center justify-between h-16">
              <div className="absolute inset-y-0 left-0 flex items-center sm:hidden">
                {/* Mobile menu button*/}
                <Disclosure.Button className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-black hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white">
                  <span className="sr-only">Open main menu</span>
                  {open ? (
                    <XIcon className="block h-6 w-6" aria-hidden="true" />
                  ) : (
                    <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                  )}
                </Disclosure.Button>
              </div>
              <div className="flex-1 flex items-center justify-center sm:items-stretch sm:justify-start">
                <div className="flex-shrink-0 flex items-center">
                  {/* <img
                    className="block lg:hidden h-8 w-auto"
                    src="https://tailwindui.com/img/logos/workflow-mark-indigo-500.svg"
                    alt="Workflow"
                  />
                  <img
                    className="hidden lg:block h-8 w-auto"
                    src="https://tailwindui.com/img/logos/workflow-logo-indigo-500-mark-white-text.svg"
                    alt="Workflow"
                  /> */}
                    <a href="/" className='text-black-300 hover:text-black px-3 py-2 rounded-md text-3xl font-medium'>
                        LL Store
                    </a>
                </div>
              </div>

              <div className="hidden sm:block sm:ml-6">
                  <div className="flex space-x-4">
                    {navigation.map((item) => (
                      <a
                        key={item.name}
                        href={item.href}
                        className={classNames(
                          item.current ? 'text-black' : 'text-black-300 hover:text-black',
                          'px-3 py-2 rounded-md text-sm font-medium text-lg'
                        )}
                        aria-current={item.current ? 'page' : undefined}
                      >
                        {item.name}
                      </a>
                    ))}
                    <h1 className='py-2 rounded-md text-sm font-medium text-xl'>{numProducts}</h1>
                  </div>
                </div>
            </div>
          </div>

          <Disclosure.Panel className="sm:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 flex flex-col items-center">
                <a className='px-3 py-2 rounded-md text-base font-medium' >Home</a>
                <a className='px-3 py-2 rounded-md text-base font-medium'>Products</a>
                <a className='px-3 py-2 rounded-md text-base font-medium'>Cart</a>

              {/* {navigation.map((item) => (
                <Disclosure.Button
                  key={item.name}
                  as="a"
                  href={item.href}
                  className={classNames(
                    item.current ? 'text-black' : 'text-black-300 hover:text-black',
                    'block px-3 py-2 rounded-md text-base font-medium'
                  )}
                  aria-current={item.current ? 'page' : undefined}
                >
                  {item.name}
                </Disclosure.Button>
              ))} */}
            </div>
          </Disclosure.Panel>
        </>
      )}
    </Disclosure>
  )
}
